import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Hidden, Box } from '@material-ui/core';
import { Container, Button, Image } from 'components';

import './styles.sass';

function PlanSection(): React.ReactElement {
  return (
    <div>
      <div className="plan-section">
        <Container>
          <div className="plan-header">
            <h2 className="plan-title">
              We have one mobile plan. {' '}It&lsquo;s only <span className="plan-title-sub">$9.99 a month.</span>
            </h2>
            <p className="plan-description">
              Everyone starts with unlimited talk, text, <br className="text-tablet-width-breakpoint" /> and 1GB of high-speed data.

          </p>
            <Hidden only="xs">
              <Link to="plan">
                <Button btnColor="gradient" className="plan-button">
                  How the Mobi Plan Works
              </Button>
              </Link>
            </Hidden>
            <Hidden smUp>
              <Link to="plan">
                <Button btnColor="gradient" className="plan-button">
                  How it Works
              </Button>
              </Link>
            </Hidden>
          </div>
          <div className="plan-content">
            <Grid container justify="center" alignItems="center" className="plan-content-item">
              <Grid item xs={12} sm={6} className="left">
                <Box width={9 / 10}>
                  <h2 className="plan-item-title">Additional Data Usage</h2>
                  <p className="plan-item-description">
                    Use as much data as you need <br className="text-desktop-width-breakpoint" /> for just $3.99/GB.
                </p>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} className="text-right right">
                <div className="plan-item-img">
                  <Image src="/images/img-graph.png" alt="Graph" />
                </div>
              </Grid>
            </Grid>
            <Grid container justify="center" alignItems="center" className="plan-content-item">
              <Grid item xs={12} sm={6}>
                <div className="plan-item-img">
                  <Image src="/images/img-monthlybill.png" alt="Monthly Bill Flexibility" />
                </div>
              </Grid>
              <Grid item xs={12} sm={6} className="text-right">
                <h2 className="plan-item-title">Monthly Bill Flexibility</h2>
                <p className="plan-item-description">Limit how much data is used <br className="text-desktop-width-breakpoint" /> whenever you want.</p>
              </Grid>
            </Grid>
            <Grid container justify="center" alignItems="center" className="plan-content-item">
              <Grid item xs={12} sm={6} className="left">
                <Box width={9 / 10}>
                  <h2 className="plan-item-title">No Contract Needed</h2>
                  <p className="plan-item-description">We don&lsquo;t want to trap you into a <br className="text-desktop-width-breakpoint" /> contract. Stay because you want to.</p>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} className="text-right right">
                <div className="plan-item-img">
                  <Image src="/images/img-contract.png" alt="No Contract Needed" wrapperClassName="contract-image" />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default PlanSection;
